export default __webpack_public_path__ + "static/media/2122 knife block B top.759a4a52.png";